module.exports = __webpack_public_path__ + "img/6.2438831d.jpg";